'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./boutiques/boutiqueCN'));

    // var iconHover = new BMap.Icon($('#mapBaidu').data('urlmarker'), new BMap.Size(45, 70));
    // var map = new BMap.Map(document.getElementById('mapBaidu'));
    // // if CN selected , display China Map
    // var center = new BMap.Point(106.554413, 29.557184);
    // map.centerAndZoom(center, 4);
    // map.addControl(new BMap.NavigationControl());
    // map.addControl(new BMap.ScaleControl());
    // map.clearOverlays();
});
